// extracted by mini-css-extract-plugin
export default {"mainPage":"styles_mainPage__yUe3g","info":"styles_info__KKACP","image":"styles_image__iVhug","texts":"styles_texts__EX2Mv","cards":"styles_cards__KEEnc"};